import { toTz, useTimezone } from "../lithic/Moment";

import { DateTimePicker as MDateTimePicker } from "@material-ui/pickers";
import React from "react";
import dayjs from "dayjs";

const defaultTz = dayjs.tz.guess();

export default function DateTimePicker({ timezone, value, ...rest }) {
  const { timezone: tzFromContext } = useTimezone() || {};
  const tz = timezone || tzFromContext || defaultTz;
  const val = toTz(value, tz);
  return <MDateTimePicker value={val} {...rest} />;
}
